import { render, staticRenderFns } from "./ProgramSynthesis.vue?vue&type=template&id=294ebc2e&"
import script from "./ProgramSynthesis.vue?vue&type=script&lang=js&"
export * from "./ProgramSynthesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports